import React from 'react';

import { Component } from '@paragon/contract-library';
import { calculateMemberPolygon, getBoundsFromPoints } from '@paragon/three-shared';

import LabelVisual from './LabelVisual';

export function PhysicalComponentLabel(props: { component: Component }) {
  const memberPoints = props.component.members.flatMap(
    (member) => calculateMemberPolygon(member, props.component)!.vertices,
  );

  const componentCenter = getBoundsFromPoints(memberPoints).position;
  const labelPosition = { ...componentCenter, y: componentCenter.y * 2, z: 0 };

  return <LabelVisual labelText={props.component.name} position={labelPosition} size={25} />;
}
